import * as THREE from "three";
import React, { useRef, useState, useEffect, memo } from "react";
import { useFrame, useThree } from "@react-three/fiber";

// side=0: left, side=1: right
const MLineMove = memo(({color, axisMove, axisShow, linewidth, side=0}) => {
  const ref  = useRef();
  const { size, camera } = useThree();
  const lastExecutionTime = useRef(Date.now());

  useFrame(( {mouse} ) => {
    const currentTime = Date.now();
    const elapsedTime = currentTime - lastExecutionTime.current;

    if (elapsedTime >= 100) {
      const maxX = (axisShow == "x") ? 500 : 0;
      const maxY = (axisShow == "y") ? 500 : 0;
      const maxZ = (axisShow == "z") ? 500 : 0;

      const mouseX = mouse.x * size.width / 2 / camera.zoom
      const mouseY = mouse.y * size.height / 2 / camera.zoom 

      if (ref.current == null) return;

      ref.current.material.linewidth = linewidth;
      
      if(axisMove == "x"){ // For Center X
        const points = [new THREE.Vector3(mouseX, -maxY, 0), new THREE.Vector3(mouseX, maxY, 0)]
        ref.current.geometry.setFromPoints(points)
      }
      else if(axisMove == "y") { 
        if (axisShow == 'x') { // MPT
          const points = [new THREE.Vector3(-maxX, mouseY, 0), new THREE.Vector3(maxX, mouseY, 0)]
          ref.current.geometry.setFromPoints(points)
        } else {
          const points = [new THREE.Vector3(0, mouseY, -maxZ), new THREE.Vector3(0, mouseY, maxZ)]
          ref.current.geometry.setFromPoints(points)
        }
      }
      else if(axisMove == "z"){ // For Center Y
        let points = null;
        if (side == 0) { // left
          points = [new THREE.Vector3(0, -maxY, -mouseX), new THREE.Vector3(0, maxY, -mouseX)]
        } else if (side == 1) { // right
          points = [new THREE.Vector3(0, -maxY, mouseX), new THREE.Vector3(0, maxY, mouseX)]
        }
        ref.current.geometry.setFromPoints(points)
      }

      lastExecutionTime.current = currentTime;
    }
  });
  
  return (
    <line ref={ref}>
      <bufferGeometry attach="geometry" />
      <lineBasicMaterial attach="material" color={color} depthTest={false} />
    </line>
  );
});

export default MLineMove;
